<div>
  {{ 'i18n.orderStatusPage.delivered' | translate }}
  {{ orderHeader?.confirmedDeliveryDate | date: 'M/d':'GMT' }}
</div>
